import { Box, Button, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import config from '@/configs/config';
import Alert from '../../../preorder/components/Alert';
import { setupTappayFields } from '../../../preorder/containers/CheckoutPage/components/Checkout';
import basket from '../../images/basket.png';
import { InverntoryStatusLabel } from '../MenuProvider';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },
  body: {
    overflow: 'auto',
  },
  description: {
    fontSize: 13,
    color: '#4f4f4f',

    '&+&': {
      marginTop: theme.spacing(1),
    },
  },
  button: {
    border: 0,
    maxHeight: 36,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 'bold',
    outline: 'none',
    padding: theme.spacing(0.5),
    width: '100%',
  },
  loginButton: {
    backgroundColor: '#2d9825',
    color: '#ffffff',
  },
  buttonGroup: {
    display: 'flex',
    marginTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  checkoutButton: {
    backgroundColor: '#eac23e',
    color: '#000000',
    marginLeft: theme.spacing(1),
  },
  addToCartButton: {
    alignItems: 'center',
    backgroundColor: '#e08816',
    color: '#000000',
    display: 'flex',
    justifyContent: 'center',
  },
  payment: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  row: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'space-between',
  },
  label: {
    flexShrink: 0,
  },
  value: {
    marginLeft: theme.spacing(2),
  },
  poImage: {
    marginTop: theme.spacing(1),
  },
}));

const useCreditCardFieldStyles = makeStyles((theme) => ({
  label: {
    color: '#535353',
  },
  field: {
    backgroundColor: '#eeeeee',
    borderRadius: 2,
    height: 40,
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  hr: {
    margin: theme.spacing(1.5, 0),
    width: '100%',
  },
}));

export const CreditCardField = ({
  fieldStyle,
  labels = [],
}) => {
  const classes = useCreditCardFieldStyles();

  useEffect(() => {
    setupTappayFields();
  }, []);

  return (
    <>
      <hr className={classes.hr} />
      <div className={classes.label}>{labels[0] || '您的信用卡號'}</div>
      <div id="card-number" className={classes.field} style={fieldStyle} />
      <div className={classes.label}>{labels[1] || '卡片有效期限'}</div>
      <div id="card-expiration-date" className={classes.field} style={fieldStyle} />
      <div className={classes.label}>{labels[2] || '卡片背面末3碼'}</div>
      <div id="card-ccv" className={classes.field} style={fieldStyle} />
    </>
  );
};

export default ({
  inventory,
  productNumber,
  onAddToCartButtonClick,
  onCheckoutButtonClick,
}) => {
  const classes = useStyles();
  const [alert, setAlert] = React.useState(null);

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        <InverntoryStatusLabel status={inventory} />
        <div className={classes.description}>本商品目前可預訂，請於收到LINE到貨通知後，至指定機台取貨。</div>
        <img
          alt=""
          className={classes.poImage}
          src={`${config.RESOURCE_URI}ProductImages/${productNumber}_info.jpg`}
          width="100%"
          onError={(e) => {
            e.currentTarget.remove();
          }}
        />
        <div className={classes.description}>
          <div>【取貨流程】</div>
          <div>
            1. 請務必先加入
            <b>
              {config.BrandNameTW}
              LINE好友
            </b>
            ，以收到貨到通知訊息。
          </div>
          <div>2. 商品上架後，LINE將會收到專屬預訂取貨碼。</div>
          <div>3. 至指定機台點選【預購取貨】再輸入六位數取貨碼開門領取即可。</div>
          <div style={{ marginTop: 8 }}>【注意事項】</div>
          <div>
            <span>1. 商品屬需保鮮之產品，為維護最佳賞味品質，請務必於收到到貨通知「當日」完成取貨！</span>
            <span>
              如於規定之取貨時段內未完成取貨，商品將下架，基於食品安全考量將無法再售出。因此恕不接受取消訂單與退款，訂購前請務必確認可配合本次商品取貨時段。
            </span>
          </div>
          <div>
            <span>
              2. 如需取消訂單，最晚請於
              <b>取貨日前三天</b>
              通知客服人員處理。
            </span>
            <span>如於之後取消或預訂，因已下單製作，恕不接受取消訂單與退款，訂購前請務必考慮清楚，敬請見諒。</span>
          </div>
          <div>3. 部分取貨點設於私人產業內，故不開放員工以外之人員取貨，敬請見諒。</div>
          <div>4. 預訂商品圖片僅供參考，實際內容物依提供之商品規格資訊與實際供貨樣式為準。</div>
        </div>
      </div>
      <div className={classes.buttonGroup}>
        <button
          className={[classes.addToCartButton, classes.button].join(' ')}
          id="add_to_cart_dailyfresh_icon"
          onClick={onAddToCartButtonClick}
          type="button"
        >
          <div style={{
            alignItems: 'center',
            background: 'white',
            border: '3px solid #e08816',
            borderRadius: '50%',
            display: 'flex',
            height: 48,
            justifyContent: 'center',
            width: 48,
          }}
          >
            <img src={basket} height="70%" alt="" />
          </div>
          <div style={{ marginLeft: 8 }}>加入餐籃</div>
        </button>
        <button
          className={[classes.checkoutButton, classes.button].join(' ')}
          onClick={onCheckoutButtonClick}
          type="button"
        >
          直接訂購
        </button>
      </div>
      {alert && (
      <Alert
        isOpen
        title={alert?.title || ''}
        content={alert?.message || ''}
        buttons={alert?.buttons || (
          <Button fullWidth onClick={() => setAlert(null)}>
            <Box fontWeight="fontWeightBold" color="support.main">
              確認
            </Box>
          </Button>
        )}
      />
      )}
    </div>
  );
};
